import type { RegisterOptions } from 'react-hook-form/dist/types/validator'

enum ErrorMessages {
  REQUIRED_FIELD = 'Diese Information ist erforderlich',
  NO_RESULT_FOR_QUERY = 'Es gibt keine Ergebnisse für diese Abfrage',
  GENDER_SELECT = 'Wähle bitte aus, wie wir dich anreden sollen.',
  INVALID_PHONE_NUMBER = 'Gib bitte eine korrekte Telefonnummer an.',
  INVALID_ECTS_FORMAT = 'Das scheinen etwas viele CP/ECTS zu sein! Hast du dich vertippt? Bitte prüfe deine Eingabe.',
  DATE_IN_THE_PAST = 'Das ausgewählte Datum sollte nicht in der Vergangenheit liegen',
  NO_VALUE_ENTERED = 'Kein Wert eingegeben',
  INVALID_IBAN_PROVIDED = 'Ungültige IBAN eingegeben',
  NOT_ALL_FIELDS_ARE_FILLED = 'Nicht alle Felder sind ausgefüllt',
  FIELDS_ARE_NEGATIVE = 'Einige Felder sind negativ',
  DATE_SHOULD_BE_AFTER_START = 'Das ausgewählte Datum sollte nach dem Startdatum liegen',
  PROVIDED_INVALID_NUMBER = 'Ungültige Nummer angegeben',
  AT_LEAST_18_YO = 'Sie müssen mindestens 18 Jahre alt sein',
  WHOLE_NUMBERS_WITHOUT_DECIMAL_PLACES = 'Bitte nur ganze Zahlen ohne Nachkommastellen angeben.',
  EMAIL_ALREADY_EXISTS = 'Angegebene E-Mail existiert bereits',
  PROVIDED_NON_GERMAN_IBAN = 'Bereitgestelltes nichtdeutsches Iban',
  DATE_SHOULD_BE_IN_THE_REQUESTED_YEAR = 'Zeitraum muss im Abrechnungsjahr liegen!',
  MAX_FIVE_CHARACTERS = 'Es sind nur maximal fünf Zeichen zulässig',
  DATE_NOT_IN_STUDY_PERIOD = 'Die angegebenen Daten für das Auslandssemester stimmen nicht mit deiner Studienzeit überein. Bitte prüfe deine Eingabe.',
}

export const defaultErrorMessage: ErrorMessages = ErrorMessages.REQUIRED_FIELD

export type TCustomMessageTypes = 'typeError' | 'email' | 'oneOf' | 'optionality'

export const messageByType: {
  [key in keyof RegisterOptions | TCustomMessageTypes]: (
    type: string | JSX.Element,
  ) => string | JSX.Element
} = {
  min: <T>(data: T): T | string => {
    if (typeof data === 'string') {
      const numbers = data.substring(data.indexOf(' ') + 1).match(/\d/g)
      if (typeof numbers?.length === 'number') {
        const numberOfCharacters = parseInt(numbers.join(''))
        return `Muss mindestens ${numberOfCharacters} Zeichen lang sein`
      }
    }
    return data
  },
  max: <T>(data: T): T | string => {
    if (typeof data === 'string') {
      const numbers = data.substring(data.indexOf(' ') + 1).match(/\d/g)
      if (typeof numbers?.length === 'number') {
        const numberOfCharacters = parseInt(numbers.join(''))
        return `Darf maximal ${numberOfCharacters} Zeichen lang sein`
      }
    }
    return data
  },
  required: () => {
    return defaultErrorMessage
  },
  validate: () => {
    return defaultErrorMessage
  },
  typeError: () => {
    return defaultErrorMessage
  },
  email: () => {
    return 'Bitte gebe eine gültige E-Mail-Adresse ein'
  },
  minLength: () => {
    return defaultErrorMessage
  },
  maxLength: () => {
    return defaultErrorMessage
  },
  pattern: () => {
    return defaultErrorMessage
  },
  valueAsNumber: () => {
    return defaultErrorMessage
  },
  valueAsDate: () => {
    return defaultErrorMessage
  },
  setValueAs: () => {
    return defaultErrorMessage
  },
  oneOf: () => {
    return defaultErrorMessage
  },
  optionality: () => {
    return defaultErrorMessage
  }
}

export default ErrorMessages
